
import styled from 'styled-components';
import { useQuery } from 'react-query';
import { useState, useRef } from 'react';
import { adminLogin, pwdChange } from '../../../interface/auth';
import theme from '../../../styles/theme';
import Button from '../../common/Button';

const MainWrap = styled.div`
    width: 50%;
    height: 50%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 16px;
    span {
        font-size: 0.8rem;
        color: ${theme.color.secondary.red};
    }
`;

const StyledInputBox = styled.input`
    outline: 0;
    border: 1.4px solid ${theme.color.black[10]};
    background: ${theme.color.white[100]};
    // border-image-source: linear-gradient(91.1deg, #fc6741 11.83%, #ed5255 88.83%) 100% / 40px;
    padding: 0px 12px;
    // margin: 6px;
    width: calc(100% - 26.8px); // padding 12 * 2 + margin 6 * 2 + border 1.4 * 2
    height: 2.5rem;
    border-radius: 8px;
    // font-size: 18px;
    // line-height 24px;
    &:-webkit-autofill {
        transition: background-color 5000s;
        background: ${theme.color.white[100]} !important;
    }
    &:-webkit-autofill:active {
        transition: background-color 5000s;
        background: ${theme.color.white[100]} !important;
    }
    &:-webkit-autofill:hover {
        transition: background-color 5000s;
        background: ${theme.color.white[100]} !important;
    }
    &:-webkit-autofill:focus {
        transition: background-color 5000s;
        background: ${theme.color.white[100]} !important;
    }
    // &:autofill {
    //     background-color: ${theme.color.white[80]};

    // }
    // &:-webkit-autofill {
    //     background-color: ${theme.color.white[80]};
    // }
`
const Password = () => {

    const pwdRef = useRef(null);
    const newPwdRef = useRef(null);

    const { data : user } = useQuery('ADMIN_USER_INFO', {});

    // const [user_no, setUser_no] = useState();
    const [pwd, setPwd] = useState();
    const [newPwd, setNewPwd] = useState();
    const [comment, setComment] = useState();

    const handleClick = () => {
        
        if(newPwd && pwd){
            const regPass = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{6,}$/;
            // console.log(newPwd,regPass.test(newPwd));
            if(regPass.test(newPwd)){
                adminLogin({user_no: user.user_no,pwd})
                    .then((res)=>{
                        if(res && res.data.length>0){
                            pwdChange({...user,pwd:newPwd})
                            .then((res)=>{
                                setComment('변경 완료하였습니다.')
                            })
                        }else{
                            setComment('비밀번호를 확인해주세요')
                        }
                    })
                    .catch((err)=>{
                        console.log(err)
                        setComment('비밀번호 변경에 실패 하였습니다. 잠시 후 시도해주시기 바랍니다. 이 상황이 지속되면 문의 바랍니다.')
                    });
            }else{
                setComment('비밀번호는 특수문자,숫자,영문을 조합한 6자리 이상이여야 합니다.')
            }
        }else{
            setComment('현재 비밀번호와 변경할 비밀번호를 입력해주세요')
        }
    }

    const handleKeydown = (e) => {
        if(e.keyCode === 13) {
            if(e.target.tabIndex === 1){
                newPwdRef.current.focus();
            }else if(e.keyCode === 13){
                handleClick();
            }
        }

    }

    return (
        <MainWrap>
            <StyledInputBox 
                ref={pwdRef} 
                type='password' 
                tabIndex={1} 
                onChange={(e)=>setPwd(e.target.value)} 
                placeholder={`현재 비밀번호`} 
                onKeyDown={handleKeydown}
                />
            <StyledInputBox 
                ref={newPwdRef} 
                type='password' 
                tabIndex={2} 
                onChange={(e)=>setNewPwd(e.target.value)} 
                placeholder={`변경 비밀번호`} 
                onKeyDown={handleKeydown}
                />
            <div style={{height:'1rem',textAlign:'center'}}>
                {comment && 
                    <span>{comment}</span>
                }
            </div>
            <Button onClick={handleClick}>비밀번호 변경</Button>
        </MainWrap>
    )

}

export default Password;